import React from 'react'
import styled from 'styled-components'
import { css } from 'styled-components'

const Square = ({id,letter,onClickHandler}) => {
  return (
    <Container onClick={()=>onClickHandler(id)}id={id}>{letter}</Container>
  )
}

const getBorder = (id) =>{

    if(id ==0 || id ==1 || id ==3 || id ==4 )
        return "border-right: 2px solid #E2EBEF; border-bottom: 2px solid #E2EBEF;"
    if(id < 6)
        return "border-bottom: 2px solid #E2EBEF;"
    if(id < 8)
        return "border-right: 2px solid #E2EBEF"
        

}

const Container = styled.div`

    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 100px;
    font-weight: bolder;
    color: #E2EBEF;
    cursor: pointer;
    ${(props) => getBorder(props.id)}


`

export default Square ;
